/* eslint-disable import/prefer-default-export */

import http from '../core/HttpClient';
import urls from '../constants/urls';

import {
  GET_DEVICE_DOCUMENTS,
  GET_DEVICE_DOCUMENT,
  REMOVE_DEVICE_DOCUMENT,
  SET_DEVICE_DOCUMENT_INFO,
  CLEAR_DEVICE_DOCUMENT,
  CLEAR_DEVICE_DOCUMENTS,
  SET_SOFTENER_EVENTS_FILTER,
  SET_SUPERIOR_EVENTS_FILTER,
  SET_SOFTENER_PARAMETERS_FILTER,
  SET_SUPERIOR_PARAMETERS_FILTER,
  SET_SUPERIOR_PRESSURES_FILTER,
  SET_SOFTENER_COLUMN_EVENTS_FILTER,
  SET_SUPERIOR_COLUMN_EVENTS_FILTER,
  SET_SOFTENER_COLUMN_PARAMETERS_FILTER,
  SET_SUPERIOR_COLUMN_PARAMETERS_FILTER,
  SET_SUPERIOR_COLUMN_PRESSURES_FILTER,
  CLEAR_SOFTENER_EVENTS_FILTER,
  CLEAR_SUPERIOR_EVENTS_FILTER,
  CLEAR_SOFTENER_PARAMETERS_FILTER,
  CLEAR_SUPERIOR_PARAMETERS_FILTER,
  CLEAR_SUPERIOR_PRESSURES_FILTER,
} from '../constants';

export function getDeviceDocumentsList(deviceid) {
  return {
    type: GET_DEVICE_DOCUMENTS,
    promise: http.get(`${urls.API2_URL}/${deviceid}/filelist`),
  };
}

export function setDeviceDocumentInfo(
  serial,
  deviceName,
  documentName,
  documentType,
  deviceType
) {
  return {
    type: SET_DEVICE_DOCUMENT_INFO,
    serial,
    deviceName,
    documentName,
    documentType,
    deviceType,
  };
}

export function removeDeviceDocument(deviceid, documentid) {
  return {
    type: REMOVE_DEVICE_DOCUMENT,
    promise: http.delete(`${urls.API2_URL}/${deviceid}/filelist/${documentid}`, { }),
  };
}

export function getDeviceDocumentById(
  deviceid,
  documentid,
  filterData,
  page, 
  pageSize
) {
  if (filterData) {
    return {
      type: 'GET_DEVICE_DOCUMENT',
      promise: http.postAsync(
        `${urls.API2_URL}/${deviceid}/filelist/${documentid}?page=${page}&page_size=${pageSize}`,
        {},
      ),
    };
  }
  return {
    type: 'GET_DEVICE_DOCUMENT',
    promise: http.get(`${urls.API2_URL}/${deviceid}/filelist/${documentid}?page=${page}&page_size=${pageSize}`),
  };
}

export function downloadDeviceDocument(deviceid, documentid, filterData, events, page, pageSize) {
  let url = `${urls.API2_URL}/${deviceid}/filelist/${documentid}/download`;
  if (page) {
    url += `?page=${page}&page_size=${pageSize}`;
  }
  if (filterData) {
    if (events) {
      return {
        type: 'DOWNLOAD_DOCUMENT',
        promise: http.postDownload(
          url,
          JSON.stringify({'filterData' : filterData, 'events' : events}),
        ),
      };
    }
    return {
      type: 'DOWNLOAD_DOCUMENT',
      promise: http.postDownload(
        url,
        JSON.stringify({'filterData' : filterData}),
      ),
    };
  }
  return {
    type: 'DOWNLOAD_DOCUMENT',
    promise: http.get(
      url,
    ),
  };
}

export function clearDeviceDocumentsList() {
  return {
    type: CLEAR_DEVICE_DOCUMENTS,
  };
}

export function clearDeviceDocument() {
  return {
    type: CLEAR_DEVICE_DOCUMENT,
  };
}

export function setDeviceDocumentFilter(documentType, name, deviceType) {
  const isSoftener = deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex';
  let ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: SET_SOFTENER_EVENTS_FILTER,
      name,
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: SET_SOFTENER_PARAMETERS_FILTER,
      name,
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: SET_SUPERIOR_EVENTS_FILTER,
      name,
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: SET_SUPERIOR_PARAMETERS_FILTER,
      name,
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: SET_SUPERIOR_PRESSURES_FILTER,
      name,
    };
  }
  return ret;
}

export function setDeviceDocumentColumnFilter(documentType, name, deviceType, screenType){
  const isSoftener = deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex';
  let ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: SET_SOFTENER_COLUMN_EVENTS_FILTER,
      name,
      screenType,
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: SET_SOFTENER_COLUMN_PARAMETERS_FILTER,
      name,
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: SET_SUPERIOR_COLUMN_EVENTS_FILTER,
      name,
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: SET_SUPERIOR_COLUMN_PARAMETERS_FILTER,
      name,
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: SET_SUPERIOR_COLUMN_PRESSURES_FILTER,
      name,
    };
  }
  return ret;
}

export function clearDocumentFilter(documentType, deviceType) {
  const devices = ['softener', 'charlie', 'simplex'];
  const isSoftener = (devices.indexOf(deviceType) > -1);
  let ret = {};
  if (documentType === 'events' && isSoftener) {
    ret = {
      type: CLEAR_SOFTENER_EVENTS_FILTER,
    };
  } else if (documentType === 'parameters' && isSoftener) {
    ret = {
      type: CLEAR_SOFTENER_PARAMETERS_FILTER,
    };
  } else if (documentType === 'events' && deviceType === 'superior') {
    ret = {
      type: CLEAR_SUPERIOR_EVENTS_FILTER,
    };
  } else if (documentType === 'parameters' && deviceType === 'superior') {
    ret = {
      type: CLEAR_SUPERIOR_PARAMETERS_FILTER,
    };
  } else if (documentType === 'pressures') {
    ret = {
      type: CLEAR_SUPERIOR_PRESSURES_FILTER,
    };
  }
  return ret;
}


// WEBPACK FOOTER //
// ./src/actions/documents.js